import { LitElement, ReactiveController, ReactiveControllerHost } from 'lit';

export class FormController implements ReactiveController {
  private host: ReactiveControllerHost;
  public form: HTMLFormElement | undefined;
  constructor(host: ReactiveControllerHost) {
    (this.host = host).addController(this);
  }

  hostConnected(): void {
    this.findRootForm();
  }

  /**
   * If form attribute present on cat-element we will use that attribute value to query element from document
    or query closest ancestor Element
   */
  private findRootForm(): void {
    const host = this.host as LitElement;
    const formId = host.getAttribute('form') || (host as any)?._form;
    this.form = (formId ? document.getElementById(formId) : host.closest('form')) as HTMLFormElement;
  }

  submit(type: 'reset' | 'submit', submitter?: HTMLElement): void {
    /**
     * When a button is placed outside a form element,
     * the 'form' property is not automatically set during the 'hostConnected' lifecycle.
     * Therefore, added this logic to handle that scenario
     */
    if ((this.host as any)?._form && !this.form) {
      this.findRootForm();
    }
    if (this.form) {
      switch (type) {
        case 'reset':
          this.form.reset();
          break;
        case 'submit':
          if (submitter) {
            submitter.hidden = true;
            this.form.appendChild(submitter);
          }
          this.form.requestSubmit(submitter);
          submitter?.remove();
          break;
      }
    }
  }
}
